export const getExpirationDays = (startDate, incrementInDays) => {
  startDate = new Date(startDate);
  const endDate = startDate;
  endDate.setDate(endDate.getDate() + incrementInDays);
  const diffTime = Math.abs(endDate - new Date());
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
};
